import { AiFillAppstore, } from "react-icons/ai";
import { FaMobile, FaGlobe,FaDeploydog, } from "react-icons/fa";
import { SiProgress, SiAntdesign,  } from "react-icons/si";

// Features Data
export const featuresData = [
 
  {
    id: 2,
    icon: <AiFillAppstore />,
    title: "Web Development",
    des: "I build and maintain Websites to make a website look great, work fast and perform well with a seamless user experience.",
  },
  {
    id: 5,
    icon: <SiAntdesign />,
    title: "Website Design",
    des: "Designing engaging and responsive landing pages.    ",
  },
  {
    id: 6,
    icon: <FaDeploydog />,
    title: "Deploy Websites",
    des: "I deploy websites for accessible to Users using web hosting platforms like Netlify,AWS...etc",
  },
];